/**
 * Column count used for group-header colSpan.
 * Headers can be empty while rows still have cells.
 * @param {{
 *   headers?: unknown[],
 *   groups?: Array<{ lib?: string, rows?: Array<{ cells?: unknown[] }> }>,
 *   footers?: unknown[],
 * }} [table]
 * @returns {number}
 */
export const getSimpleTableColCount = (table) => {
  const headerCount = Array.isArray(table?.headers) ? table.headers.length : 0;
  const footerCount = Array.isArray(table?.footers) ? table.footers.length : 0;

  const rowCellCount = (table?.groups ?? []).reduce((max, group) => {
    const rows = Array.isArray(group?.rows) ? group.rows : [];
    return rows.reduce((rowMax, row) => {
      const cells = Array.isArray(row?.cells) ? row.cells.length : 0;
      return Math.max(rowMax, cells);
    }, max);
  }, 0);

  return Math.max(headerCount, footerCount, rowCellCount, 1);
};
